import React from "react";
import GeneralEnquiry from "./GeneralEnquiry";
import AskAMedicalExpertLink from "./AskAMedicalExpertLink";
import MakeAClaimLink from "./MakeAClaimLink";
import MakeAComplaintLink from "./MakeAComplaintLink";
import UploadGPReferralLetter from "./UploadGPReferralLetter";
import style from "../../../../src/assets/css/modules/contact-us/online-link.css";
import { connect } from "react-redux";
import { shouldShowIfAllSMEModulesDontMatch } from "../../../helpers/SMEModules/smeModuleHelper";
import { nonClaimsModules } from "../../../constants/SMEModulesToMatchOn";
import ContactUsChat from "./ContactUsChat";

export const OnlineLinks = function( props ) {
  return (
    <>
    <div className={`${style.contactUs} row`} >
    {/* <div className="row align-items-stretch "> */}
      <div className="col-lg-3">
        <UploadGPReferralLetter featureFlagEP={props.featureFlagEP} url={props.urlGPReferralLetter}
          linkText="Upload a GP referral letter"
          isDisabled={props.isDisabled}
          disableStyle={props.disableStyle} />
      </div>
       {props.shouldShowMakeAClaimLink && (
        <div className="col-lg-3" data-make-a-claim>
          <MakeAClaimLink />
        </div>
      )}
      <div className="col-lg-3">
        <AskAMedicalExpertLink featureFlagEP={props.featureFlagEP} url={props.urlAskMedExpert}
          isDisabled={props.isDisabled}
          disableStyle={props.disableStyle} />
      </div>
      <div className="col-lg-3">
        <GeneralEnquiry featureFlagEP={props.featureFlagEP} url={props.urlGeneralEnquiry}
          isDisabled={props.isDisabled}
          disableStyle={props.disableStyle} />
      </div>
      {/* based on props.shouldShowMakeAClaimLink value, deciding the number of columns to be added in first row, 
      otherwise a below column(makeacomplaintlink) will get added to next row*/}
      {!props.shouldShowMakeAClaimLink && (
        <div className="col-lg-3">
        <MakeAComplaintLink featureFlagEP={props.featureFlagEP} url={props.urlMakeComplaint}
          isDisabled={props.isDisabled}
          disableStyle={props.disableStyle} />
      </div>
      )}
    </div>
     <div className="row">
        {props.shouldShowMakeAClaimLink && (<div className="col-lg-3">
          <MakeAComplaintLink featureFlagEP={props.featureFlagEP} url={props.urlMakeComplaint}
            isDisabled={props.isDisabled}
            disableStyle={props.disableStyle} />
        </div>)}
         <div className="col-lg-3">
           <ContactUsChat featureFlagEP={props.featureFlagEP}
          linkText="Live chat"
          isDisabled={props.isDisabled}
          disableStyle={props.disableStyle} />
        </div>
     </div>
    </>
  );
};

export const mapStateToOnlineLinks = ({ policyReducer }) => {
  return {
    shouldShowMakeAClaimLink: shouldShowIfAllSMEModulesDontMatch(
      policyReducer.selectedPolicy,
      nonClaimsModules
    )
  };
};

export default connect(mapStateToOnlineLinks)(OnlineLinks);
